<template>
    <div class="hiscore-entry-row bg-light" :class="{ 'has-entry': !!entry }">
        <div class="flag">
            <country-flag :country="countryCode" size='big' />
        </div>
        <div class="entry-details">
            <div v-if="entry">
                <div class="name">{{ entry.name }}</div>
                <div class="details">{{ entry.score }}/10 - {{ formattedTime }}</div>
            </div>
            <div v-else>
                <div class="name">No entry</div>
            </div>
        </div>
    </div>
</template>

<script>
import CountryFlag from 'vue-country-flag'

export default {
    props: {
        entry: {
            type: Object,
            default: null
        }
    },
    computed: {
        formattedTime() {
            if (!this.entry || !this.entry.total_time) return '';

            // Extract hours, minutes, seconds and milliseconds from the total_time string
            const [hours, minutes, seconds] = this.entry.total_time.split(':').map(Number);

            let timeString = '';
            if (hours > 0) timeString += `${hours}h `;
            if (minutes > 0) timeString += `${minutes}m `;
            if (seconds > 0 || timeString === '') timeString += `${Math.floor(seconds)}s`;

            return timeString.trim();
        },
        countryCode() {
            if (!this.entry || !this.entry.countrycode) return 'un'

            return this.entry.countrycode
        }
    }
};
</script>

<style scoped>
.hiscore-entry-row {
    display: flex;
    align-items: center;
    padding: 1rem;
    margin-bottom: 0.5rem;
    border-radius: 0.25rem;
    background-color: #f8f9fa;
    /* Light background */
}

.flag {
    margin-right: 1rem;
    font-size: 2rem;
    /* Adjust icon size as needed */
    display: flex;
    align-items: center;
    /* Center the icon vertically */
}

.entry-details {
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* Center the text vertically */
}

.name {
    font-weight: bold;
    font-size: 1.2rem;
    text-align: start;
}

.details {
    font-size: 1rem;
    justify-content: left;
    text-align: start;
}
</style>
